module.exports = __webpack_public_path__ + "static/img/banner.18d4e80.png";